import React, { useState } from "react";
import axios from "axios";
import Costanti from '../../constantiX';
import { Formik } from 'formik';
import * as Yup from 'yup';
import ReactGA from 'react-ga4';
import { InputText,InputTextarea,Button,FileUpload,Toast, Dialog, DataTable, Column} from "primereact";



    class Azienda extends React.Component {
      constructor() {
            super();
           this.token=sessionStorage.getItem("ICEtoken");
           this.utente=JSON.parse(sessionStorage.getItem("utente"));
           this.aziendaid=0;
           this.ruoloid=this.utente.ruoloid;
           this.state = { xcarica:'sezione', tipo:'', collegate:[], immagine:'', dati:[], totalRecords:0, pageSize:10, first:0, rows:10, visible1:false, visible2: false,visible3: false, loading:true, editMode:true, isSubmitting:false};
      }

      componentDidMount() {
        //alert(this.props.location.pathname);
          ReactGA.send({ hitType: "pageview", page:this.props.location.pathname});
          this.aziendaid=this.utente.aziendaid;
          this.caricaDati(1,this.state.pageSize);  
          this.caricaCollegate();  
          
      }
      
      showMessage(tipo,messageError,dettaglio) {
        var icona='';
        if(tipo=='error'){icona='pi pi-times-circle';}
        if(tipo=='info'){icona='pipi-info-circle';}
        if(tipo=='success'){icona='pi pi-check-circle';}
        if(tipo=='warning'){icona='pi pi-exclamation-triangle';}
        this.toastBC.show({ severity: tipo,  life: 3000, closable: false, content: (
            <div className="flex flex-column" style={{flex: '1'}}>
                <div className="text-center">
                 <i className={icona} style={{fontSize: '3rem'}}></i>
                 <h4>{messageError}</h4>
                 <h5>{dettaglio}</h5>
                </div>
            </div>
        ) });
      }
      
      validationSchema() {
          return Yup.object().shape({
            email: Yup.string()
              .required('Email obbligatoria')
              .typeError('Email obbligatoria')
              .email('Email non valida'),
              partitaiva: Yup.string()
                .max(11, "Lunghezza errata!")

          });
      }
        
      inviaDati(dati) {
          let config = {
            headers: {
              'Authorization': 'Bearer ' + this.token
            }
          }
          this.setState({isSubmitting:true});
     
        axios.post(Costanti.UrlCallApi+"azienda/salva/"+this.aziendaid,dati,config)
        .then(res => {
            this.showMessage('success','Dati salvati correttamente','');
            this.setState({isSubmitting:false});
       }).catch(error=> {
          this.showMessage('error','Errore nel salvataggio',error.message);
          this.setState({isSubmitting:false});
        });
      }
      setVisible1(val){
        this.setState({ visible1: val });
     } 
     setVisible2(val){
      this.setState({ visible2: val });
   } 
     
   traduci(){

    alert('a');
  
  
      }
       
      elAllegato(){
        let config = {
          headers: {
            'Authorization': 'Bearer ' + this.token
          }
        }
       axios.get(Costanti.UrlCallApi+"file/delete/"+this.utente.aziendaid+'/logo/'+this.aziendaid,config)
      .then(res => {
         }).catch(error=> {
           alert(error)
      });         
      window.location.reload(false);
    }
      
        
      caricaCollegate(){
        let config = {
            headers: {
              'Authorization': 'Bearer ' + this.token
            }
          }
          this.setState({loading:true});
         axios.get(Costanti.UrlCallApi+"azienda/collegate/"+this.aziendaid,config)
        .then(res => {
           this.setState({collegate:res.data.lista1,loading:false})

            //alert(JSON.stringify(this.state.prodotti))
           }).catch(error=> {
             alert(error)
        });
    } 



       caricaDati(pagina,numrec){
            let config = {
                headers: {
                  'Authorization': 'Bearer ' + this.token
                }
              }
              this.setState({loading:true});
             axios.get(Costanti.UrlCallApi+"azienda/"+this.aziendaid,config)
            .then(res => {
               this.setState({dati:res.data,tipo:res.data.tipo,totalRecords:res.data.conta1,loading:false,immagine:Costanti.UrlCallApi+'file/get/'+this.aziendaid+'/logo/'+this.aziendaid})

                //alert(JSON.stringify(this.state.prodotti))
               }).catch(error=> {
                 alert(error)
            });
        } 
        lingua(){
          var a="";
          if(document.getElementById("aaGG"))
          a=document.getElementById("aaGG").innerText;
          if(a==="") a=(navigator.language=== 'it-IT'?"IT":"UK");
          return a;
        }


        render() {
        return( 
          <div className="flex">
          <Toast ref={(el) => this.toastBC = el} position="bottom-center" />
        <Formik  initialValues={{ 
        ragionesociale: this.state.dati.ragionesociale, 
        email: this.state.dati.email, 
        sede: this.state.dati.sede,
        pec: this.state.dati.pec,
        partitaiva: this.state.dati.partitaiva,
        codicefiscale: this.state.dati.codicefiscale,
        sitoweb: this.state.dati.sitoweb,
        telefono: this.state.dati.telefono,
        info: this.state.dati.info,
        infoen: this.state.dati.infoen,
        ateco1:this.state.dati.ateco1,
        ateco2:this.state.dati.ateco2,
        facebook:this.state.dati.facebook,
        instagram:this.state.dati.instagram
      }}
          enableReinitialize
          validationSchema={this.validationSchema}
          onSubmit={(values) => {
          this.inviaDati(values);
       }}>
       {({
         values,
         errors,
         touched,
         handleChange,
         handleBlur,
         handleSubmit,
        
       }) => (
        <form onSubmit={handleSubmit}>
        <div className="text-600 font-medium text-600 text-xl mb-3" onDoubleClick={()=>this.traduci()}><span style={{ color : this.state.tipo==='FOOD' ? 'green' :'navy'}}> Dati Identificativi Azienda</span></div>
    
 
    
        <div className="surface-card p-2  border-round">
            <div className="grid formgrid p-fluid">
            <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
             
                <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="ragionesociale" className="font-medium text-600">Ragione Sociale</label>
                    <InputText name="ragionesociale" value={values.ragionesociale}  onChange={handleChange} onBlur={handleBlur} type="text" />
                </div>
                <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="sede" className="font-medium text-600">Sede Principale</label>
                    <InputText type="text" name="sede" value={values.sede} onChange={handleChange} onBlur={handleBlur} />
                      </div>
                <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="partitaiva" className="font-medium text-600">Partita Iva</label>
                    <InputText name="partitaiva" type="text" value={values.partitaiva} onChange={handleChange} onBlur={handleBlur} />
                    <div style={{color:'red'}}>{errors.partitaiva && touched.partitaiva && errors.partitaiva}</div>
                </div>
                <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="telefono" className="font-medium text-600">Telefono</label>
                    <InputText type="text" name="telefono" value={values.telefono} onChange={handleChange} onBlur={handleBlur} />
   
                </div>
                <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="email" className="font-medium text-600">Email</label>
                    <InputText type="email" name="email" value={values.email} onChange={handleChange} onBlur={handleBlur} />
                    <div style={{color:'red'}}>{errors.email && touched.email && errors.email}</div>
                </div>
                <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="pec" className="font-medium text-600">Pec</label>
                    <InputText type="email" name="pec" onChange={handleChange} onBlur={handleBlur} value={values.pec}/>
               </div>
                <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="sitoweb" className="font-medium text-600">Sito Web</label>
                    <div className="p-inputgroup">
              
                        <InputText type="text" name="sitoweb" value={values.sitoweb} onChange={handleChange} onBlur={handleBlur} />
                          </div>
                </div>
                <div className="field mb-1 col-12 md:col-6"/>
                {/*
                <div className="field mb-1 col-12 md:col-6">
                <div className="mb-1 flex align-items-center justify-content-between">
                <Button type="button" label="Aziende Controllate" onClick={()=>this.setVisible1(true)} icon="pi pi-eye" className="p-button-rounded p-button-warning "/>
                <Button type="button" label="Aggiungi Azienda Controllata" onClick={()=>this.setVisible2(true)}   icon="pi pi-plus" className="p-button-rounded p-button-primary "/>
                </div> 
                </div>
                */}
                <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="facebook" className="font-medium text-600">facebook</label>
                    <InputText type="text" name="facebook" onChange={handleChange} onBlur={handleBlur} value={values.facebook}/>
               </div>
               <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="instagram" className="font-medium text-600">instagram</label>
                    <InputText type="text" name="instagram" onChange={handleChange} onBlur={handleBlur} value={values.instagram}/>
               </div>
                <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="ateco1" className="font-medium text-600">Codice Ateco Prevalente</label>
                    <InputText type="text" name="ateco1" onChange={handleChange} onBlur={handleBlur} value={values.ateco1}/>
               </div>
               <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="ateco2" className="font-medium text-600">Codice Ateco Secondario</label>
                    <InputText type="text" name="ateco2" onChange={handleChange} onBlur={handleBlur} value={values.ateco2}/>
               </div>
                    
                <div className="field mb-1 col-12 md:col-6">
                   {this.lingua()=='IT'?<>
                    <label htmlFor="info" className="font-medium text-600">
                    <img src="images/flag_placeholder.png" className="flag flag-it"/>Note Aggiuntive
                    
                      </label>
                    <InputTextarea id="info" type="text" rows={10} autoResize value={values.info} onChange={handleChange} onBlur={handleBlur}/>
                    </>:
                    <><label htmlFor="infoen" className="font-medium text-600">
                       <img src="images/flag_placeholder.png" className="flag flag-uk"/>Note Aggiuntive
                       </label>
                    <InputTextarea id="infoen" type="text" rows={10} autoResize value={values.infoen} onChange={handleChange} onBlur={handleBlur}/>
                    </>}
                 </div>
                   
                <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="avatar2" className="font-medium text-600">Logo Azienda</label>
                    <div className="flex align-items-center">
                    {this.state.dati.hasImage? 
                    <img src={this.state.immagine} style={{maxHeight:'200px',maxHeight:'200px'}} alt="" className="mr-2 card" />:""}
                        <FileUpload id="avatar2" mode="basic" name="avatar"
                          url={Costanti.UrlCallApi+'file/carica/'+this.utente.aziendaid+'/logo/'+this.aziendaid} 
                          onError={()=> this.showMessage('error','Errore','Si è verificato un errore nel caricamento')}
                          onUpload={()=>window.location.reload(false)}
                          accept="image/*" maxFileSize={10000000} chooseOptions={{ className: 'p-button-plain p-button-outlined' }}
                          chooseLabel={this.state.dati.hasImage?"Modifica":"Aggiungi"} />
                  {this.state.dati.hasImage?<Button type="button" label="Elimina" className="w-auto ml-1" 
                  onClick={(e)=>{e.stopPropagation();this.elAllegato()}}></Button>:""}   
                  </div>
                   
                </div>
              <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
                <div className="col-12">
                    <Button label="Salva" className="w-auto mt-3" type="submit" />
                </div>
            </div>
        </div>
        </form>
        )}
         </Formik>


         <Dialog visible={this.state.visible1} closable={false} modal breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '60vw' }} header="Lista Aziende Controllate" draggable={false} resizable={false} footer={<div className="border-top-1 surface-border pt-3">
            <Button icon="pi pi-check" onClick={() => this.setVisible1(false)} label="Chiudi" />
            </div>}>
            <div className="flex flex-wrap border-top-1 surface-border pt-4">
            <DataTable value={this.state.collegate}   responsiveLayout="stack">
              
            <Column id="id1" field="ragionesociale" header="Ragione Sociale" />
            <Column id="id2" field="indirizzo" header="Indirizzo" />
            <Column id="id3" field="partitaiva" header="Partita iva" />
            <Column id="id3" field="pec" header="PEC" />
            
            </DataTable> 
     
            </div>
        </Dialog>

        <Dialog visible={this.state.visible2} closable={false} modal breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '60vw' }} header="Aggiungi Azienda" draggable={false} resizable={false} footer={<div className="border-top-1 surface-border pt-3">
            <Button icon="pi pi-check" onClick={() => this.setVisible2(false)} label="Chiudi" />
            </div>}>
            <div className="flex flex-wrap border-top-1 surface-border pt-4">
                    Aprire una richiesta al Supporto!
            </div>
        </Dialog>
    </div>
  
    )
    }
};

export default Azienda;
